import { useState } from "react";
import { Modal } from "../../ui/Modal";

export function ApiKeySecretModal({
  token,
  prefix,
  onClose,
}: {
  token: string;
  prefix: string;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <Modal>
      <div className="fixed inset-0 z-dialog flex items-center justify-center bg-black/40 p-4">
        <div className="flex w-full max-w-md flex-col gap-3 rounded-lg bg-surface p-4 text-fg shadow-2xl">
          <h2 className="text-sm font-semibold">API key {prefix}</h2>
          <code className="block break-all rounded border border-line bg-canvas p-2 font-mono text-[11px]">
            {token}
          </code>
          <button
            type="button"
            className="w-fit rounded border border-line px-2 py-1 text-[11px] hover:bg-hover"
            onClick={() => {
              void navigator.clipboard.writeText(token).then(() => {
                setCopied(true);
              });
            }}
          >
            {copied ? "Copied" : "Copy"}
          </button>
          <p className="text-[12px] text-amber-500">
            This is the only time this key is shown. Store it now.
          </p>
          <button
            type="button"
            className="w-fit rounded bg-fg px-3 py-1.5 text-[12px] font-medium text-canvas"
            onClick={onClose}
          >
            I've stored it
          </button>
        </div>
      </div>
    </Modal>
  );
}
